var _defs, _circle, _path, _circle2, _path2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 8.7,
    cy: 19.66,
    r: 4.49
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M18.5 22.28l19.64-3.9c.61 3.05-3.3 6.39-8.72 7.47-1.17.23-2.31.34-3.39.34M18.5 22.28l-9.05 1.8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 14.56,
    cy: 31.37,
    r: 4.49
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M32.95 8.11c-2.12-2.27-7.14-1.03-11.23 2.77-4.08 3.8-5.68 8.73-3.56 11l12.19-11.36 2.59-2.42zM18.16 21.88l-6.75 6.29"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 22.19,
    cy: 25.59,
    r: 1.44
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/custom.a2a4819f51f159df54f6c0d3589aac4c.svg";
export { ForwardRef as ReactComponent };